(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-bigtext"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var COLLAPSED_HEIGHT = 200; /* px: CSSの --cbgt-collapsed-height と合わせる */

  function initBigtext(section) {
    var clip       = section.querySelector('[data-bigtext-clip]');
    var wrapper    = section.querySelector('[data-bigtext-wrapper]');
    var body       = section.querySelector('[data-bigtext-body]');
    var fade       = section.querySelector('[data-bigtext-fade]');
    var toggleWrap = section.querySelector('[data-bigtext-toggle-wrap]');
    var toggle     = section.querySelector('[data-bigtext-toggle]');
    var closeWrap  = section.querySelector('[data-bigtext-close-wrap]');
    var closeBtn   = section.querySelector('[data-bigtext-close]');

    if (!wrapper || !body || !toggle) return;

    /* コンテンツが折りたたみ高さ以下なら UI 一切非表示 */
    if (body.scrollHeight <= COLLAPSED_HEIGHT) {
      wrapper.style.maxHeight = 'none';
      wrapper.classList.add('is-expanded');
      if (fade) fade.style.display = 'none';
      if (toggleWrap) toggleWrap.style.display = 'none';
      return;
    }

    /* ---- 展開 ---- */
    toggle.addEventListener('click', function () {
      wrapper.classList.add('is-expanded');
      toggle.setAttribute('aria-expanded', 'true');

      if (fade) fade.classList.add('is-hidden');
      if (toggleWrap) toggleWrap.classList.add('is-hidden');
      if (closeWrap) closeWrap.classList.add('is-visible');
      if (closeBtn) closeBtn.setAttribute('aria-expanded', 'true');
    });

    /* ---- 折りたたむ ---- */
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        wrapper.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        closeBtn.setAttribute('aria-expanded', 'false');

        if (fade) fade.classList.remove('is-hidden');
        if (toggleWrap) toggleWrap.classList.remove('is-hidden');
        if (closeWrap) closeWrap.classList.remove('is-visible');

        /* 折りたたんだ後、セクション上端へスクロール */
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  /* 初期化 */
  function boot() {
    document.querySelectorAll('.collection-bigtext').forEach(initBigtext);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* テーマエディタでのセクション再読み込み対応 */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.collection-bigtext');
    if (s) initBigtext(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-iglike-lite"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  /* =============================================
     共通：モーダル表示関数（サムネイル・ミニプレーヤー共用）
     ============================================= */
  const iglikeModal = document.getElementById("IglikeVideoModal");
  let iglikeModalSwiper = null;
  var iglikeMuted = true; // モーダル内のミュート状態を管理

  function openIglikeModal(index) {
    iglikeModal.classList.add("show");
    iglikeModalSwiper.slideTo(index, 0);
    setTimeout(function () {
      playVideoInSlide(iglikeModalSwiper);
    }, 30);
  }

  function playVideoInSlide(swiper) {
    swiper.slides.forEach(function (slide, index) {
      const video = slide.querySelector("video");
      if (video) {
        if (index === swiper.activeIndex) {
          video.muted = iglikeMuted;
          video.currentTime = 0;
          video.play().catch(function (err) {
            console.warn("再生できません:", err);
          });
        } else {
          video.pause();
          video.currentTime = 0;
        }
      }
    });
    // 全ボタンのアイコンを現在のミュート状態に同期
    document.querySelectorAll(".iglike-sound-toggle i").forEach(function (icon) {
      icon.className = iglikeMuted ? "fa fa-volume-off" : "fa fa-volume-up";
    });
  }

  function stopAllVideos() {
    iglikeMuted = true; // モーダルを閉じたらミュートにリセット
    document.querySelectorAll(".iglike-modal video").forEach(function (video) {
      video.muted = true;
      video.pause();
      video.currentTime = 0;
    });
    // 全ボタンのアイコンもリセット
    document.querySelectorAll(".iglike-sound-toggle i").forEach(function (icon) {
      icon.className = "fa fa-volume-off";
    });
  }


  /* =============================================
     サムネイルスライダー
     ============================================= */
  if (document.querySelector(".iglike-item-slider")) {
    var iglikeItemSlider = new Swiper(".iglike-item-slider", {
      slidesPerView: 5,
      spaceBetween: 20,
      speed: 600,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: ".iglike-swiper-button-next",
        prevEl: ".iglike-swiper-button-prev",
      },
      pagination: {
        el: ".iglike-swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
      on: {
        init: function () {
          this.el.classList.remove("iglike-item-slider__pre-init");
        },
      },
    });
  }


  /* =============================================
     モーダルスライダー
     ============================================= */
  iglikeModalSwiper = new Swiper(".iglike-modal-swiper", {
    direction: "vertical",
    spaceBetween: 10,
    navigation: {
      nextEl: ".iglike-modal-next",
      prevEl: ".iglike-modal-prev",
    },
    mousewheel: true,
    on: {
      slideChangeTransitionEnd: function (swiper) {
        playVideoInSlide(swiper);
      },
    },
  });


  /* =============================================
     サムネイルクリック → モーダル表示
     ============================================= */
  document.querySelectorAll(".iglike-mov-thumbnail").forEach(function (thumb, index) {
    thumb.addEventListener("click", function () {
      openIglikeModal(index);
    });
  });


  /* =============================================
     サウンドトグルボタン
     ============================================= */
  document.querySelectorAll(".iglike-sound-toggle").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      iglikeMuted = !iglikeMuted;
      // 現在アクティブなスライドの動画のミュートを切り替え
      var activeSlide = iglikeModalSwiper.slides[iglikeModalSwiper.activeIndex];
      if (activeSlide) {
        var video = activeSlide.querySelector("video");
        if (video) {
          video.muted = iglikeMuted;
        }
      }
      // 全ボタンのアイコンを同期
      document.querySelectorAll(".iglike-sound-toggle i").forEach(function (icon) {
        icon.className = iglikeMuted ? "fa fa-volume-off" : "fa fa-volume-up";
      });
    });
  });


  /* =============================================
     モーダルを閉じる
     ============================================= */
  var iglikeCloseModalBtns = document.querySelectorAll(".iglike-modal-close");

  iglikeCloseModalBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      iglikeModal.classList.remove("show");
      stopAllVideos();
    });
  });

  iglikeModal.addEventListener("click", function (e) {
    if (e.target === iglikeModal) {
      iglikeModal.classList.remove("show");
      stopAllVideos();
    }
  });


  /* =============================================
     ミニプレーヤー
     ============================================= */
  var miniPlayerEl = document.getElementById("IglikeMiniPlayer");
  var miniPlayerVideo = document.getElementById("IglikeMiniPlayerVideo");
  var miniPlayerClose = document.getElementById("IglikeMiniPlayerClose");
  var miniPlayerDataEl = document.getElementById("IglikeMiniPlayerData");

  if (miniPlayerEl && miniPlayerVideo && miniPlayerDataEl) {
    var miniVideoUrls = [];
    try {
      miniVideoUrls = JSON.parse(miniPlayerDataEl.textContent);
    } catch (e) {
      console.warn("ミニプレーヤー: 動画データの解析に失敗しました", e);
    }

    if (miniVideoUrls.length > 0) {
      var miniCurrentIndex = 0;
      var miniDismissed = false;

      // 動画をセットして再生
      function miniPlayAt(index) {
        miniPlayerVideo.src = miniVideoUrls[index];
        miniPlayerVideo.load();
        miniPlayerVideo.play().catch(function (err) {
          console.warn("ミニプレーヤー: 再生できません:", err);
        });
      }

      // 動画終了時：次があれば次へ、なければリピート
      miniPlayerVideo.addEventListener("ended", function () {
        if (miniVideoUrls.length > 1 && miniCurrentIndex < miniVideoUrls.length - 1) {
          miniCurrentIndex++;
        } else if (miniVideoUrls.length > 1) {
          miniCurrentIndex = 0;
        }
        // 同じ動画でもsrc再セットでリプレイ
        miniPlayAt(miniCurrentIndex);
      });

      // 外部JS（テーマの画像ギャラリー等）による意図しないpauseを検知して再開
      miniPlayerVideo.addEventListener("pause", function () {
        if (!miniDismissed && miniPlayerVideo.src && !miniPlayerVideo.ended) {
          miniPlayerVideo.play().catch(function () {});
        }
      });

      // ミニプレーヤーを非表示にする
      function dismissMiniPlayer() {
        miniDismissed = true;
        miniPlayerEl.classList.remove("is-visible");
        miniPlayerEl.addEventListener("transitionend", function handler() {
          miniPlayerEl.classList.add("is-hidden");
          miniPlayerVideo.pause();
          miniPlayerVideo.removeAttribute("src");
          miniPlayerVideo.load();
          miniPlayerEl.removeEventListener("transitionend", handler);
        });
      }

      // 閉じるボタン
      miniPlayerClose.addEventListener("click", function (e) {
        e.stopPropagation();
        dismissMiniPlayer();
      });

      // ミニプレーヤー本体クリック → ミニプレーヤーを閉じてモーダルを開く
      miniPlayerEl.addEventListener("click", function () {
        var targetIndex = miniCurrentIndex;
        dismissMiniPlayer();
        openIglikeModal(targetIndex);
      });

      // 初期化：動画の準備が整ってからフェードイン
      miniPlayerVideo.addEventListener("loadeddata", function handler() {
        miniPlayerVideo.removeEventListener("loadeddata", handler);
        requestAnimationFrame(function () {
          miniPlayerEl.classList.add("is-visible");
        });
      });
      miniPlayAt(miniCurrentIndex);
    }
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-iglike-multi"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  // 既に初期化済みのセクションをスキップするためのマーカー属性
  var INITIALIZED_ATTR = "data-iglike-multi-initialized";

  document.querySelectorAll(".iglike-multi-wrapper").forEach(function (sectionEl) {
    if (sectionEl.hasAttribute(INITIALIZED_ATTR)) return;
    sectionEl.setAttribute(INITIALIZED_ATTR, "true");
    initIglikeMultiSection(sectionEl);
  });


  function initIglikeMultiSection(sectionEl) {

    /* =============================================
       共通：モーダル表示関数
       ============================================= */
    var iglikeModal = sectionEl.querySelector(".iglike-multi-modal");
    var iglikeModalSwiper = null;
    var iglikeMuted = true; // モーダル内のミュート状態を管理

    function openIglikeModal(index) {
      if (!iglikeModal || !iglikeModalSwiper) return;
      iglikeModal.classList.add("show");
      iglikeModalSwiper.slideTo(index, 0);
      setTimeout(function () {
        playVideoInSlide(iglikeModalSwiper);
      }, 30);
    }

    function playVideoInSlide(swiper) {
      swiper.slides.forEach(function (slide, index) {
        var video = slide.querySelector("video");
        if (video) {
          if (index === swiper.activeIndex) {
            video.muted = iglikeMuted;
            video.currentTime = 0;
            video.play().catch(function (err) {
              console.warn("再生できません:", err);
            });
          } else {
            video.pause();
            video.currentTime = 0;
          }
        }
      });
      // 自セクション内の全ボタンのアイコンを現在のミュート状態に同期
      sectionEl.querySelectorAll(".iglike-multi-sound-toggle i").forEach(function (icon) {
        icon.className = iglikeMuted ? "fa fa-volume-off" : "fa fa-volume-up";
      });
    }

    function stopAllVideos() {
      iglikeMuted = true; // モーダルを閉じたらミュートにリセット
      sectionEl.querySelectorAll(".iglike-multi-modal video").forEach(function (video) {
        video.muted = true;
        video.pause();
        video.currentTime = 0;
      });
      // 全ボタンのアイコンもリセット
      sectionEl.querySelectorAll(".iglike-multi-sound-toggle i").forEach(function (icon) {
        icon.className = "fa fa-volume-off";
      });
    }


    /* =============================================
       サムネイルスライダー
       ============================================= */
    var itemSliderEl = sectionEl.querySelector(".iglike-multi-item-slider");
    if (itemSliderEl) {
      var iglikeItemSlider = new Swiper(itemSliderEl, {
        slidesPerView: 5,
        spaceBetween: 20,
        speed: 600,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: sectionEl.querySelector(".iglike-multi-swiper-button-next"),
          prevEl: sectionEl.querySelector(".iglike-multi-swiper-button-prev"),
        },
        pagination: {
          el: sectionEl.querySelector(".iglike-multi-swiper-pagination"),
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 2.2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 20,
          }
        },
        on: {
          init: function () {
            this.el.classList.remove("iglike-multi-item-slider__pre-init");
          }
        }
      });
    }


    /* =============================================
       モーダルスライダー
       ============================================= */
    var modalSwiperEl = sectionEl.querySelector(".iglike-multi-modal-swiper");
    if (modalSwiperEl) {
      iglikeModalSwiper = new Swiper(modalSwiperEl, {
        direction: "vertical",
        spaceBetween: 10,
        navigation: {
          nextEl: sectionEl.querySelector(".iglike-multi-modal-next"),
          prevEl: sectionEl.querySelector(".iglike-multi-modal-prev"),
        },
        mousewheel: true,
        on: {
          slideChangeTransitionEnd: function (swiper) {
            playVideoInSlide(swiper);
          }
        }
      });
    }


    /* =============================================
       サムネイルクリック → モーダル表示
       ============================================= */
    sectionEl.querySelectorAll(".iglike-multi-mov-thumbnail").forEach(function (thumb, index) {
      thumb.addEventListener("click", function () {
        openIglikeModal(index);
      });
    });


    /* =============================================
       サウンドトグルボタン
       ============================================= */
    sectionEl.querySelectorAll(".iglike-multi-sound-toggle").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        iglikeMuted = !iglikeMuted;
        // 現在アクティブなスライドの動画のミュートを切り替え
        var activeSlide = iglikeModalSwiper.slides[iglikeModalSwiper.activeIndex];
        if (activeSlide) {
          var video = activeSlide.querySelector("video");
          if (video) {
            video.muted = iglikeMuted;
          }
        }
        // 自セクション内の全ボタンのアイコンを同期
        sectionEl.querySelectorAll(".iglike-multi-sound-toggle i").forEach(function (icon) {
          icon.className = iglikeMuted ? "fa fa-volume-off" : "fa fa-volume-up";
        });
      });
    });


    /* =============================================
       モーダルを閉じる
       ============================================= */
    sectionEl.querySelectorAll(".iglike-multi-modal-close").forEach(function (btn) {
      btn.addEventListener("click", function () {
        iglikeModal.classList.remove("show");
        stopAllVideos();
      });
    });

    iglikeModal.addEventListener("click", function (e) {
      if (e.target === iglikeModal) {
        iglikeModal.classList.remove("show");
        stopAllVideos();
      }
    });


    /* =============================================
       クリック時のURLにviaパラメータ付与
       ============================================= */
    sectionEl.querySelectorAll("a").forEach(function (elm) {
      try {
        var url = new URL(elm.href);
        url.searchParams.set("via", "iglike");
        elm.href = url.toString();
      } catch (e) {
        console.warn("invalid link:", elm.href);
      }
    });
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-iglike"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  /* =============================================
     共通：モーダル表示関数（サムネイル・ミニプレーヤー共用）
     ============================================= */
  const iglikeModal = document.getElementById("IglikeVideoModal");
  let iglikeModalSwiper = null;
  var iglikeMuted = true; // モーダル内のミュート状態を管理

  function openIglikeModal(index) {
    if (!iglikeModal || !iglikeModalSwiper) return;
    iglikeModal.classList.add("show");
    iglikeModalSwiper.slideTo(index, 0);
    setTimeout(function () {
      playVideoInSlide(iglikeModalSwiper);
    }, 30);
  }

  function playVideoInSlide(swiper) {
    swiper.slides.forEach(function (slide, index) {
      const video = slide.querySelector("video");
      if (video) {
        if (index === swiper.activeIndex) {
          video.muted = iglikeMuted;
          video.currentTime = 0;
          video.play().catch(function (err) {
            console.warn("再生できません:", err);
          });
        } else {
          video.pause();
          video.currentTime = 0;
        }
      }
    });
    // 全ボタンのアイコンを現在のミュート状態に同期
    document.querySelectorAll(".iglike-sound-toggle i").forEach(function (icon) {
      icon.className = iglikeMuted ? "fa fa-volume-off" : "fa fa-volume-up";
    });
  }

  function stopAllVideos() {
    iglikeMuted = true; // モーダルを閉じたらミュートにリセット
    document.querySelectorAll(".iglike-modal video").forEach(function (video) {
      video.muted = true;
      video.pause();
      video.currentTime = 0;
    });
    // 全ボタンのアイコンもリセット
    document.querySelectorAll(".iglike-sound-toggle i").forEach(function (icon) {
      icon.className = "fa fa-volume-off";
    });
  }


  /* =============================================
     サムネイルスライダー
     ============================================= */
  if (document.querySelector(".iglike-item-slider")) {
    const iglikeItemSlider = new Swiper(".iglike-item-slider", {
      slidesPerView: 5,
      spaceBetween: 20,
      speed: 600,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: ".iglike-swiper-button-next",
        prevEl: ".iglike-swiper-button-prev",
      },
      pagination: {
        el: ".iglike-swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 20,
        }
      },
      on: {
        init: function () {
          this.el.classList.remove("iglike-item-slider__pre-init");
        }
      }
    });
  }


  /* =============================================
     モーダルスライダー
     ============================================= */
  iglikeModalSwiper = new Swiper(".iglike-modal-swiper", {
    direction: "vertical",
    spaceBetween: 10,
    navigation: {
      nextEl: ".iglike-modal-next",
      prevEl: ".iglike-modal-prev",
    },
    mousewheel: true,
    on: {
      slideChangeTransitionEnd(swiper) {
        playVideoInSlide(swiper);
      }
    }
  });


  /* =============================================
     サムネイルクリック → モーダル表示
     ============================================= */
  document.querySelectorAll(".iglike-mov-thumbnail").forEach(function (thumb, index) {
    thumb.addEventListener("click", function () {
      openIglikeModal(index);
    });
  });


  /* =============================================
     サウンドトグルボタン
     ============================================= */
  document.querySelectorAll(".iglike-sound-toggle").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      iglikeMuted = !iglikeMuted;
      // 現在アクティブなスライドの動画のミュートを切り替え
      var activeSlide = iglikeModalSwiper.slides[iglikeModalSwiper.activeIndex];
      if (activeSlide) {
        var video = activeSlide.querySelector("video");
        if (video) {
          video.muted = iglikeMuted;
        }
      }
      // 全ボタンのアイコンを同期
      document.querySelectorAll(".iglike-sound-toggle i").forEach(function (icon) {
        icon.className = iglikeMuted ? "fa fa-volume-off" : "fa fa-volume-up";
      });
    });
  });


  /* =============================================
     モーダルを閉じる
     ============================================= */
  const iglikeCloseModalBtns = document.querySelectorAll(".iglike-modal-close");

  iglikeCloseModalBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      iglikeModal.classList.remove("show");
      stopAllVideos();
    });
  });

  iglikeModal.addEventListener("click", function (e) {
    if (e.target === iglikeModal) {
      iglikeModal.classList.remove("show");
      stopAllVideos();
    }
  });


  /* =============================================
     クリック時のURLにviaパラメータ付与
     ============================================= */
  document.querySelectorAll(".iglike-wrapper a").forEach(function(elm) {
    try {
      let url = new URL(elm.href);
      url.searchParams.set("via", "iglike");
      elm.href = url.toString();
    } catch (e) {
      console.warn("invalid link:", elm.href);
    }
  });


  /* =============================================
     ミニプレーヤー
     ============================================= */
  const miniPlayerEl = document.getElementById("IglikeMiniPlayer");
  const miniPlayerVideo = document.getElementById("IglikeMiniPlayerVideo");
  const miniPlayerClose = document.getElementById("IglikeMiniPlayerClose");
  const miniPlayerDataEl = document.getElementById("IglikeMiniPlayerData");
  const miniPlayerInfoEl = document.getElementById("IglikeMiniPlayerInfo");
  const miniPlayerInfoImage = document.getElementById("IglikeMiniPlayerInfoImage");
  const miniPlayerInfoTitle = document.getElementById("IglikeMiniPlayerInfoTitle");

  if (miniPlayerEl && miniPlayerVideo && miniPlayerDataEl) {
    let miniVideos = [];
    try {
      miniVideos = JSON.parse(miniPlayerDataEl.textContent);
    } catch (e) {
      console.warn("ミニプレーヤー: 動画データの解析に失敗しました", e);
    }

    if (miniVideos.length > 0) {
      let miniCurrentIndex = 0;
      let miniDismissed = false;
      let miniShown = false;

      // トリガーとなるスクロール率を取得（0-100）
      const triggerScrollRaw = parseFloat(miniPlayerEl.dataset.triggerScroll);
      const triggerScroll = isNaN(triggerScrollRaw)
        ? 5
        : Math.min(100, Math.max(0, triggerScrollRaw));

      // 現在再生中の商品情報をオーバーレイに反映
      function updateMiniPlayerInfo(index) {
        if (!miniPlayerInfoEl) return;
        const data = miniVideos[index] || {};
        const title = data.title || "";
        const image = data.image || "";

        if (title) {
          miniPlayerInfoTitle.textContent = title;
          if (image) {
            miniPlayerInfoImage.src = image;
          } else {
            miniPlayerInfoImage.removeAttribute("src");
          }
          miniPlayerInfoEl.classList.remove("is-empty");
        } else {
          miniPlayerInfoTitle.textContent = "";
          miniPlayerInfoImage.removeAttribute("src");
          miniPlayerInfoEl.classList.add("is-empty");
        }
      }

      // 動画をセットして再生
      function miniPlayAt(index) {
        miniPlayerVideo.src = miniVideos[index].url;
        miniPlayerVideo.load();
        miniPlayerVideo.play().catch(function (err) {
          console.warn("ミニプレーヤー: 再生できません:", err);
        });
        updateMiniPlayerInfo(index);
      }

      // 動画終了時：次があれば次へ、なければリピート
      miniPlayerVideo.addEventListener("ended", function () {
        if (miniVideos.length > 1 && miniCurrentIndex < miniVideos.length - 1) {
          miniCurrentIndex++;
        } else if (miniVideos.length > 1) {
          miniCurrentIndex = 0;
        }
        // 同じ動画でもsrc再セットでリプレイ
        miniPlayAt(miniCurrentIndex);
      });

      // ミニプレーヤーを非表示にする
      function dismissMiniPlayer() {
        miniDismissed = true;
        miniPlayerEl.classList.remove("is-visible");
        miniPlayerEl.addEventListener("transitionend", function handler() {
          miniPlayerEl.classList.add("is-hidden");
          miniPlayerVideo.pause();
          miniPlayerVideo.removeAttribute("src");
          miniPlayerVideo.load();
          miniPlayerEl.removeEventListener("transitionend", handler);
        });
      }

      // ミニプレーヤーを表示する（フェードイン）
      function showMiniPlayer() {
        if (miniShown || miniDismissed) return;
        miniShown = true;
        // 動画のロードが済んでから表示、未ロードなら loadeddata を待つ
        if (miniPlayerVideo.readyState >= 2) {
          requestAnimationFrame(function () {
            miniPlayerEl.classList.add("is-visible");
          });
        } else {
          miniPlayerVideo.addEventListener("loadeddata", function handler() {
            miniPlayerVideo.removeEventListener("loadeddata", handler);
            requestAnimationFrame(function () {
              miniPlayerEl.classList.add("is-visible");
            });
          });
        }
      }

      // 閉じるボタン
      miniPlayerClose.addEventListener("click", function (e) {
        e.stopPropagation();
        dismissMiniPlayer();
      });

      // ミニプレーヤー本体クリック → ミニプレーヤーを閉じてモーダルを開く
      miniPlayerEl.addEventListener("click", function () {
        const targetIndex = miniCurrentIndex;
        dismissMiniPlayer();
        openIglikeModal(targetIndex);
      });

      // 動画の先読み開始（再生はしない）
      miniPlayerVideo.src = miniVideos[miniCurrentIndex].url;
      miniPlayerVideo.load();

      // スクロール率の計算
      function getScrollPercent() {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0) return 100; // ページが短い場合は即表示扱い
        return (window.scrollY / scrollable) * 100;
      }

      // トリガー判定
      function checkTrigger() {
        if (miniShown || miniDismissed) return;
        if (getScrollPercent() >= triggerScroll) {
          // 動画の準備が整ってから再生＆表示
          miniPlayAt(miniCurrentIndex);
          showMiniPlayer();
          window.removeEventListener("scroll", onScroll);
        }
      }

      function onScroll() {
        checkTrigger();
      }

      if (triggerScroll === 0) {
        // 0%の場合はロード後すぐに表示
        miniPlayAt(miniCurrentIndex);
        showMiniPlayer();
      } else {
        // 初回チェック（既にスクロール位置が閾値を超えている場合に対応）
        checkTrigger();
        if (!miniShown) {
          window.addEventListener("scroll", onScroll, { passive: true });
        }
      }
    }
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["original-tags-filter"] && !Shopify.designMode) return;
  try {
    
  if(document.getElementById('filter-by-tags')){
    let uri = decodeURI(location.pathname);
    let temp = uri.split("/");
    uri = "/" + temp[1] + "/" + temp[2] + "/";
    let selected_tags = [];
    if(typeof temp[3] !== 'undefined'){
      selected_tags = temp[3].split("+");
    }
    filter_by_tags_setlink(uri,selected_tags);
  }
  function filter_by_tags_setlink(uri,selected_tags){
    let display_tags = [];
    const items = document.querySelectorAll('.filter-by-tags_item-value');
    items.forEach(function(e) {
      let tag = e.dataset.tag;
      if(selected_tags.length > 0){
        let check_tag_index = selected_tags.indexOf(tag);
        if(check_tag_index !== -1){
          let removed_tags = selected_tags.concat();
          removed_tags.splice(check_tag_index, 1);
          e.classList.add("__selected");
          display_tags.push(tag);
          e.setAttribute('href',uri+removed_tags.join('+'));
        }else{
          e.setAttribute('href',uri+selected_tags.join('+')+"+"+tag);
        }
      }else{
        e.setAttribute('href',uri+tag);
      }
    });
    const rankingState = document.querySelector('.product-ranking-container__close');
    if(display_tags.length > 0){
      const display_tags_label = display_tags.join(',');
      document.getElementById('filter-selector_selected-tags').textContent = display_tags_label;
      if (rankingState) {
        rankingState.addEventListener('click', function() {
          rankingState.classList.remove('product-ranking-container__close');
        });
      }
    }else{
      document.getElementById('filter-selector_selected-tags').textContent = "サイズや種類で絞り込む";
      if (rankingState) {
        rankingState.classList.remove('product-ranking-container__close');
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["original-tags-filter2026"] && !Shopify.designMode) return;
  try {
    
if(document.getElementById('filter-by-tags')){
let uri = decodeURI(location.pathname);
let temp = uri.split("/");
uri = "/" + temp[1] + "/" + temp[2] + "/";
let selected_tags = [];
if(typeof temp[3] !== 'undefined'){
selected_tags = temp[3].split("+");
}
filter_by_tags_setlink(uri,selected_tags);
}
function filter_by_tags_setlink(uri,selected_tags){
let display_tags = [];
const items = document.querySelectorAll('.filter-by-tags_item-value');
items.forEach(function(e) {
let tag = e.dataset.tag;
if(selected_tags.length > 0){
let check_tag_index = selected_tags.indexOf(tag);
if(check_tag_index !== -1){
let removed_tags = selected_tags.concat();
removed_tags.splice(check_tag_index, 1);
e.classList.add("__selected");
display_tags.push(tag);
e.setAttribute('href',uri+removed_tags.join('+'));
}else{
e.setAttribute('href',uri+selected_tags.join('+')+"+"+tag);
}
}else{
e.setAttribute('href',uri+tag);
}
});
const rankingState = document.querySelector('.product-ranking-container__close');
if(display_tags.length > 0){
const display_tags_label = display_tags.join(',');
document.getElementById('filter-selector_selected-tags').textContent = display_tags_label;
if (rankingState) {
rankingState.addEventListener('click', function() {
rankingState.classList.remove('product-ranking-container__close');
});
}
}else{
document.getElementById('filter-selector_selected-tags').textContent = filter_by_tags_default_label;
if (rankingState) {
rankingState.classList.remove('product-ranking-container__close');
}
}
}

  } catch(e) { console.error(e); }
})();
})();
